import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from '@libs/vc-core-lib';
import { Observable } from 'rxjs';
import { IAssessmentBundleDTO } from '../dto/assessment.bundle.dto';
import { IAssessmentBundleModel } from '../model/assessment-bundle.model';
import { IAssessmentBundleLinkedAssessmentModel } from '../model/assessment-bundle-linked-assessment.model';

@Injectable({ providedIn: 'root' })
export class AssessmentBundleService {
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _assessmentBundlePath = 'assessment-bundle';

    public createAssessmentBundle(assessment: IAssessmentBundleDTO): Observable<IAssessmentBundleModel> {
        return this._httpClient.post<IAssessmentBundleModel>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/${this._assessmentBundlePath}`,
            assessment
        );
    }

    public getByAssessmentBundleId(assessmentBundleId: number): Observable<IAssessmentBundleLinkedAssessmentModel[]> {
        return this._httpClient.get<IAssessmentBundleLinkedAssessmentModel[]>(
            `${this._environment.APP.VC_ASSESSMENT_BASE_URL}/${this._assessmentBundlePath}/${assessmentBundleId}/assessments`
        );
    }
}
